module.exports = __webpack_public_path__ + "img/VirtualCapabilities_00012.24e1c1dc.jpg";